import React from 'react';
import './dock.less';
import { Observable } from 'rxjs';
import KeyBinder from '../../utils/KeyBinder';

export default class Dock extends React.Component {
	static defaultProps = {
		initialWidth: 500,
		minWidth: 320,
		position: 'left'
	};
	componentDidMount() {
		const mousedown$ = Observable.fromEvent(this.dragHandle, 'mousedown')
			.filter(e => e.button == 0);
		const mouseup$   = Observable.fromEvent(document, 'mouseup');
		const mousemove$ = Observable.fromEvent(document, 'mousemove');

		const drag$ = mousedown$.flatMap(md => {
      		var mouseDownX = md.offsetX;
      		var windowWidth = window.innerWidth;

      		var dragHandleWidth = this.dragHandle.getBoundingClientRect().width;
      		var leftOffsetDragHandle = dragHandleWidth - mouseDownX;

      		var getWidthFromClientX = ({clientX}) => {
      			if(this.props.position == 'left') {
      				return clientX + leftOffsetDragHandle;	
      			}

      			return windowWidth - clientX + mouseDownX;
      		};

      		return mousemove$.map(mm => {
      			mm.preventDefault();
      			return getWidthFromClientX(mm);
      		})
      		.filter(width => {
      			return width > this.props.minWidth;
      		})
      		.takeUntil(mouseup$);
		});

		drag$.subscribe(width => {
			this.props.changeWidth(width);
		});

		this.keyBinder = new KeyBinder({escapePressed: this.onEsc.bind(this)});
	}
	componentWillUnmount() {
		this.keyBinder.destroy();
	}
	onEsc() {
		this.props.onClose();
	}
	updatePosition(position) {
		this.props.changePosition(position);
	}
	render() {
		var { width, position } = this.props;
		var isLeft = position == 'left';
		var positionStyle = isLeft ? {left: 0} : {right: 0};
		var dragHandleStyles = isLeft ? 
			{right: 0, boxShadow: 'rgba(0, 0, 0, 0.298039) 4px 0px 8px'} : 
			{left: 0, boxShadow: '-5px 0px 5px -3px #616161'};

		return (
			<div style={{width, ...positionStyle}} 
				ref={el => this.dock = el}
				className="dock">
				{React.cloneElement(this.props.children, { width, position, updatePosition: this.updatePosition.bind(this) })}
				<div
					style={dragHandleStyles}
					ref={node => this.dragHandle = node}
					className="dock-drag-handle"></div>
			</div>
		);

	}
}


// WEBPACK FOOTER //
// ./app/components/dock/Dock.js